import { gql, useQuery, UseQueryState } from 'urql';

import {
  MANDATORY_MASTER_FIELDS,
  MANDATORY_VARIANT_FIELDS,
} from 'gql/fragments/product';
import {
  PAGINATED_OUTPUT_NODES_FRAGMENT,
  PAGINATED_OUTPUT_METADATA_FRAGMENT,
} from 'gql/fragments/products';
import { PaginatedOutput, SearchInput } from '__generated__/graphql';

import { CommonQueryOptions, commonQueryVariables } from './products';

export const TRENDING_SEARCH_TERMS = gql`
  query TrendingSearchTerms {
    trendingSearchTerms {
      searchTerm
      rank
    }
  }
`;

export const SEARCH_RECOMMENDED_PRODUCTS = gql`
  query SearchRecommendedProducts {
    searchFlyoutRecommendedProducts {
      __typename
      id
      variantProduct {
        id
        masterId
        colorValue
        name
        header
        subHeader
        productPrice {
          price
          salePrice
        }
        images {
          alt
          href
        }
      }
    }
  }
`;

const PRODUCT_SEARCH_QUERY = gql`
  query ProductSearch(
    $q: String
    $sort: String
    $filters: [FilterInputOption!]!
    $expansions: [ProductSearchExpansion!]
    $includeSearchMetadata: Boolean = true
    $offset: Int!
    $limit: Int!
  ) {
    search(
      input: {
        q: $q
        sort: $sort
        filters: $filters
        limit: $limit
        offset: $offset
        expansions: $expansions
        includeSearchMetadata: $includeSearchMetadata
      }
    ) {
      __typename
      ...PaginatedOutputNodesFragment
      ...PaginatedOutputMetadataFragment @include(if: $includeSearchMetadata)
    }
  }

  ${PAGINATED_OUTPUT_NODES_FRAGMENT}
  ${PAGINATED_OUTPUT_METADATA_FRAGMENT}
  ${MANDATORY_MASTER_FIELDS}
  ${MANDATORY_VARIANT_FIELDS}
`;

export type ProductSearchQueryOptions = CommonQueryOptions;

export type ProductSearchQueryResult = { search: PaginatedOutput };

export type ProductSearchQueryState = UseQueryState<
  ProductSearchQueryResult,
  SearchInput
>;

export const useProductSearchQuery = (options: ProductSearchQueryOptions) =>
  useQuery<ProductSearchQueryResult, SearchInput>({
    query: PRODUCT_SEARCH_QUERY,
    pause: options.pause,
    variables: {
      ...commonQueryVariables(options),
      includeSearchMetadata: options.includeMetadata,
    },
  });
